import React from 'react';
import {Link} from 'react-router-dom';

import AdminLayout from 'Pages/Admin/AdminLayout';

import Delete from 'Components/Partials/Modals/Delete';
import {ModalTrigger} from 'Components/Modal';
import {FormHandler, Label, DatePicker, Input} from 'Components/Form';
import Select from 'Components/Form/Select';
import {PrimaryButton, SecondaryButton} from 'Components/Button';
import {DangerButton} from 'Components/Button';
import {Alert, Loading} from 'Components/Partials';

import Poll from 'Services/Api/Admin/MainStage/Polls';
import {Toast} from 'Services';

class Store extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Poll has been submitted successfully';

    /**
     * @var state
     * @type {{pollId: *, sessionId: *, loading: boolean}}
     */
    state = {
        loading: false,
        sessionId: this.props.match.params.session,
        pollId: this.props.match.params?.poll
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        if (this.state.pollId) {
            this.fetchPoll();
        } else {
            this.props.setInitialValues({
                type: 'single',
                answers: [
                    ''
                ]
            });
        }
    };

    /**
     * @method fetchPoll
     * @return {Promise<void>}
     */
    fetchPoll = async () => {
        this.setState({loading: true});

        const request = await Poll.get({
            session: this.state.sessionId,
            poll: this.state.pollId,
        });

        if (request.success) {
            const poll = request.data.data;

            this.props.setInitialValues({
                ...poll,
                answers: poll.answers.map(a => a.answer)
            });

            return this.setState({
                loading: false
            });
        }

        Toast.error();
    };

    /**
     * @method handleAnswerInput
     * @param {string} value
     * @param {number} k
     */
    handleAnswerInput = (value, k) => {
        const {form, handleInput} = this.props;

        form.answers[k] = value;

        handleInput('answers', form.answers);
    };

    /**
     * @method handleAddAnswer
     */
    handleAddAnswer = () => {
        const {form, handleInput} = this.props;

        form.answers.push('');

        handleInput('answers', form.answers);
    };

    /**
     * @method handleDeleteAnswer
     * @param {object} k
     */
    handleDeleteAnswer = (k) => {
        const {form, handleInput} = this.props;

        form.answers.splice(k, 1);

        handleInput('answers', form.answers);
    };

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<boolean|{status: number}>|Promise<AxiosResponse<any>>|*}
     */
    handleSubmit = (form) => {
        if (this.state.pollId) {
            return Poll.patch({
                session: this.state.sessionId,
                poll: this.state.pollId
            }, form);
        } else {
            return Poll.post({
                session: this.state.sessionId
            }, form);
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {working, alert, form, handleInput, handleSubmit} = this.props;
        const {loading, sessionId, pollId} = this.state;

        return (
            <AdminLayout title="Main Stage - Polls">
                {loading && (
                    <Loading />
                )}

                {!loading && (
                    <form
                        className="divide-y divide-gray-200"
                        onSubmit={e => handleSubmit(e, this.handleSubmit, this.success, !pollId)}
                    >
                        <div className="mx-6">
                            {alert && (<Alert {...alert} />)}

                            <Input
                                value={form.question}
                                onChange={v => handleInput('question', v)}
                                containerClassName="mb-4"
                                label="Question"
                            />

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                <DatePicker
                                    label="Display From"
                                    selected={form.display_from}
                                    onChange={date => handleInput('display_from', date)}
                                    showTimeSelect={true}
                                    timeIntervals={5}
                                    nowButton={true}
                                />

                                <DatePicker
                                    label="Display Until"
                                    selected={form.display_until}
                                    onChange={date => handleInput('display_until', date)}
                                    showTimeSelect={true}
                                    timeIntervals={5}
                                    nowButton={true}
                                />
                            </div>

                            <div className="mb-4">
                                <Select
                                    label="Type"
                                    id="type"
                                    value={form.type}
                                    onChange={v => handleInput('type', v)}
                                    options={[
                                        { label: 'Single Choice', value: 'single' },
                                        { label: 'Ranking', value: 'ranking' },
                                    ]}
                                />
                            </div>

                            <div className="mb-4">
                                <Label label="Answers" />

                                {form.answers?.map((item, k) => (
                                    <div className="grid grid-cols-6 mb-2 gap-4" key={k}>
                                        <div className="col-span-5">
                                            <Input
                                                value={item}
                                                onChange={(v) => this.handleAnswerInput(v, k)}
                                            />
                                        </div>

                                        <div className="flex items-center">
                                            <ModalTrigger
                                                component={Delete}
                                                props={{
                                                    message: 'Are you sure you want delete this answer? Any results submitted will be deleted',
                                                    onDelete: () => this.handleDeleteAnswer(k)
                                                }}
                                            >
                                                <DangerButton type="button" className="w-full text-center" text="Remove" />
                                            </ModalTrigger>
                                        </div>
                                    </div>
                                ))}

                                <div className="w-full text-center">
                                    <PrimaryButton text="Add Answer" onClick={this.handleAddAnswer} />
                                </div>
                            </div>
                        </div>

                        <div className="px-6 pt-6 flex justify-end gap-4">
                            <Link to={`/admin/main-stage/polls/${sessionId}`}>
                                <SecondaryButton type="button" text="Back" />
                            </Link>

                            <PrimaryButton working={working} text="Save"/>
                        </div>
                    </form>
                )}
            </AdminLayout>
        );
    }
}

export default FormHandler(Store);
